import FormInputRowModeTypes from "./FormInputRowModeTypes"

type FormInputRowStateToModeMapType = {
  numberModes: FormInputRowModeTypes[];
  stringModes: FormInputRowModeTypes[];
  selectModes: FormInputRowModeTypes[];
  symbolModes: FormInputRowModeTypes[];
  fixedModes: FormInputRowModeTypes[];
  singleDateModes: FormInputRowModeTypes[];
  booleanModes: FormInputRowModeTypes[];  
  formModes: FormInputRowModeTypes[];
  refreshModes: FormInputRowModeTypes[];
}

const FormInputRowModeTypesToGroupMap : FormInputRowStateToModeMapType = {
  numberModes: ["float", "integer", "percent", "dollar", "price"], // "slider"],
  stringModes: ["string"], // "select", 'autocomplete'],
  symbolModes: ['symbol'],
  selectModes: ["select"],
  fixedModes: ["fixed"],
  singleDateModes: ['date'],
  booleanModes: ['checkbox', 'switch'],
  formModes: ['form'],
  refreshModes: ['refresh'],
  // doubleDateModes: ['daterange'],
  // relativeDateModes: ["relativeDate"],
  // relativePriceModes: ["relativePrice"],
  // add price optoin for StrategyInputRowOptionTypesEnum that reference stock price
};

export default FormInputRowModeTypesToGroupMap;
